import { useQuery } from "@tanstack/react-query";
import EnterpriseApiRoutes from "common/ApiRoutes";
import fetch from "logic/rest/FetchProvider";
import { qualifyUrl } from "util/URLUtils";
export const fetchAIAgentTriageInvestigationOutput = (investigationId) => fetch("GET", qualifyUrl(EnterpriseApiRoutes.SecurityApp.Investigations.aiAgentTriage(investigationId).url));
const useAIAgentTriageInvestigationOutput = (investigationId) => useQuery({
  queryKey: ["security-app", "investigations", investigationId, "ai-agent-triage"],
  queryFn: () => fetchAIAgentTriageInvestigationOutput(investigationId),
  enabled: !!investigationId
});
export default useAIAgentTriageInvestigationOutput;
